export const getBusinessFilters = state => state.business.businessFilters;

export const getBusinessGridSortCriteria = state => state.business.businessGridSortCriteria;
